'use strict';

class CustomFieldList {
  constructor(recipientService) {
    this.recipientService = recipientService;
  }

  $onInit() {
    this.fields = [];

    this.load();
  }

  load() {
    this.recipientService.getCustomFields()
      .then((resp) => {
        this.fields = resp.data;
      });
  }

  remove(number) {
    swal({
      title: 'Bekreft fjerning',
      showCancelButton: true,
      confirmButtonColor: '#970b0e',
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nei',
      closeOnConfirm: false,
      showLoaderOnConfirm: true
    }, (answer) => {
      if (answer) {
        this.recipientService.deleteCustomField(number)
          .then(() => {
            swal.close();
            this.load();
          });
      }
    });
  }
}

CustomFieldList.$inject = ['recipientService'];

const customFieldList = {
  controller: CustomFieldList,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <h2>Egendefinerte felter</h2>
      </div>
      <div class="large-6 columns right-align">
        <a href="#/egendefinerte-felter/nytt" role="button" class="button secondary"><i class="fa fa-plus"></i> Legg til nytt felt</a>
      </div>
    </div>

    <div ng-show="$ctrl.fields.length">
      <input type="text" ng-model="$ctrl.q" placeholder="Filtrer">

      <table>
        <thead>
          <tr>
            <th>Navn</th>
            <th>Type</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="field in $ctrl.fields | filter:$ctrl.q track by field.number">
            <td>{{ field.name }}</td>
            <td>
              <span ng-if="field.type === 'TEXT' && !field.options.length">Tekst</span>
              <span ng-if="field.type === 'TEXT' && field.options.length">Liste</span>
              <span ng-if="field.type === 'DATE'">Dato</span>
              <span ng-if="field.type === 'NUMBER'">Tall</span>
              <span ng-if="field.type === 'BOOLEAN'">Ja/Nei</span>
            </td>
            <td class="right-align">
              <a href role="button" class="button small alert" ng-click="$ctrl.remove(field.number)"><i class="fa fa-trash"></i> Slett</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('customFieldList', customFieldList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/egendefinerte-felter', {
        title: 'Egendefinerte felter',
        template: '<custom-field-list />',
        secure: true
      });
  });
